/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectList_itemSearch$ref = any;
export type SbSharedRefineMenuFilterMatchingSets_itemSearch$ref = any;
export type SbSharedRefineMenuFilterMatchingSets_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectList_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterMatchingSets_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterMatchingSets_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '46ec47273c86b37f5ce41cb0d420a07d';
export default node;
